import React from "react";
import Helmet from "react-helmet";
import Alert from "../../utils/alert";
import { Button } from "react-bootstrap";
import Swal from "sweetalert2";

export default function Paet() {

	const parrafos = [
		"Al suscribir el citado formulario está iniciando su trámite para certificar su calidad de enfermo terminal, el que podrá ser apelado ante el Consejo Médico de apelación.",
		"Si se encuentra tramitando una pensión de vejez o vejez anticipada, dicho trámite se deberá suspender, para proceder con el trámite de pensión para enfermo terminal. En caso de ser rechazada su certificación, la solicitud de pensión de vejez o anticipada se reanudará.",
		"En caso de no estar pensionado y estar cubierto por el SIS o para acceder a beneficios complementarios, se solicitará su calificación de invalidez.",
		"La evaluación o reevaluación de invalidez que esté en trámite, continuará aun cuando se hubiese negado la certificación por parte del Consejo Médico de la Superintendencia.",
		"El objetivo de la solicitud de pensión de invalidez es que, en caso de aprobarse, se realice el pago del aporte adicional por parte de las Compañías de Seguros de Vida o se pueda acceder a otras prestaciones como pensionado por invalidez.",
		"El detalle del trámite completo de la certificación y de la calificación de invalidez en carácter prioritario, y sus posibles resultados.",
		"Si el dictamen del Consejo Médico declara su calidad de enfermo terminal tendrá derecho a percibir una renta temporal por doce meses, dejando una reserva para pensiones de sobrevivencia y cuota mortuoria. Podrá retirar excedente si existen fondos suficientes.",
		"En ningún caso, una vez certificado como enfermo terminal, podrá optar por una pensión bajo la modalidad de renta vitalicia.",
		"Los antecedentes entregados serán evaluados por los Médicos del Consejo Médico de la Superintendencia y, si corresponde, por integrantes de la Comisión Médica Regional, como parte del expediente de invalidez y certificación.",
		"La solicitud debe complementarse con el certificado Médico exigido por Ley, firmado por el Médico tratante y el director Médico (o equivalente) de la institución de salud tratante."
	];

	const handleShow = () => {

		const htmlContent = `<div style="margin-bottom: 1rem; text-align: center;">Información importante para realizar tu solicitud</div>
		${parrafos.map((text, index) => `<div className="text-modal"><strong>${index + 1}.</strong> ${text}</div>`).join('<br>')}`;

		Swal.fire({
			icon: "",
			confirmButtonText: "Comenzar solicitud PAET",
			cancelButtonText: "Volver",
			showCancelButton: true,
			reverseButtons: true,
			html: htmlContent,
			allowOutsideClick: false,
			customClass: {
				confirmButton: "btn btn-success",
				cancelButton: "btn btn-danger",
				htmlContainer: "text-modal"
			},
		}).then((result) => {
			if (result.isConfirmed) {
				window.location.href = "/paet/index";
			}
		});

	};

	return (
		<>
			<Helmet>
				<title>Retiro Enfermos Terminales AFP Modelo | Solicitud de Retiro Enfermos Terminales | AFP Modelo</title>
				<meta name="description" content={``} />
				<meta name="robots" content="noindex, follow" />
			</Helmet>
			<section>
				<div className="container">
					<div className="center h1">
						Retiro de fondos con AFP Modelo
					</div>
					<div className="center h2">
						INFÓRMATE Y HAZ EL RETIRO DE TUS FONDOS
					</div>
					<div className="card formulario mt-5 mb-5">
						<div className="card-header">
							<div className="form-row">
								<div className="titulo">
									Retiro de Pensión Anticipada por Enfermedad Terminal (PAET)
								</div>
							</div>
							<div className="form-row">
								<div className="subtitulo mt-3">
									Instrucciones de ingreso de solicitud:
								</div>
							</div>
						</div>
						<div className="card-body paet">
							<div className="mb-0">
								Antes de ingresar su solicitud, usted o su representante, debe
								obtener de parte de su médico tratante y del establecimiento
								de salud público o privado que corresponda, un certificado
								médico que acredite su condición de salud, el que deberá
								adjuntarse a la solicitud. Su médico tratante deberá llenar
								directamente el certificado en el siguiente link:
								<a href="https://certificadoset.portalafp.cl/">
									{" "}
									Sistema para Certificados de Enfermos Terminales
								</a>
							</div>
							<div className="mb-4">
								(Para conocer un ejemplo del certificado médico{" "}
								<a
									target="_blank"
									href="https://modelo.blob.core.windows.net/retiros10porciento/Certificado_Medico.pdf"
								>
									Haz click aquí
								</a>
								)
							</div>
							<div className="mb-4">
								Su médico tratante, deberá enviarlo al establecimiento de
								salud público o privado que corresponda, donde haya recibido
								atenciones respecto de su enfermedad, para completar los datos
								correspondientes, firmar y timbrar por el director médico o su
								equivalente, el que deberá entregárselo por los medios que a
								usted le resulten más convenientes.
							</div>
							<div className="mb-4">
								El certificado, debidamente llenado, firmado y timbrado,
								deberá adjuntarse a la solicitud que presente usted o su
								representante, por esta vía o por cualquiera de los canales de
								servicio de la AFP. Además, deberá adjuntar la autorización
								para que el Consejo Médico pueda acceder a la revisión de la
								ficha clínica (Disponible para su llenado y envío en este
								link:
								<a
									target="_blank"
									href="https://modelo.blob.core.windows.net/retiros10porciento/Autorizacion_Consejo_Medico.pdf"
								>
									descargar autorización para revisión de ficha por consejo
									médico
								</a>
								).Adicionalmente, se le recomienda adjuntar la mayor cantidad
								de antecedentes médicos sobre su condición de salud principal.
							</div>
							<div className="justify-content-center d-flex">
								<Button
									variant="success"
									type="submit"
									className="col-md-12"
									onClick={handleShow}
								>
									Solicitar pensión PAET{" "}
								</Button>
							</div>
							<div>
								<Alert
									image="warning"
									className="alert-secondary"
									message={[
										"Este portal es ",
										<strong key="s">
											exclusivo para los Afiliados, Pensionados AFP Modelo.
										</strong>,
										" Si no sabes a qué AFP estás afiliado, ",
										<a
											key="a"
											href="https://www.spensiones.cl/apps/certificados/formConsultaAfiliacion.php"
											target="blank_"
											className="green-a"
										>
											haz click aquí
										</a>,
										".",
									]}
								/>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
}
